import Quill from 'quill';
import { CloudinaryUploadResponse } from 'types';

interface ImageUploadOptions {
  uploadFunc: (filename: string, file: File) => Promise<CloudinaryUploadResponse>;
}
class ImageUpload {
  options: ImageUploadOptions;
  quill: Quill;

  constructor(quill: Quill, options = {} as ImageUploadOptions) {
    this.quill = quill;
    this.options = options;
    this.quill.getModule('toolbar').addHandler('image', this.selectLocalImage);
  }

  selectLocalImage = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/png, image/jpeg, image/gif');
    input.click();

    input.onchange = () => {
      const file = input.files && input.files[0];

      if (file && /^image\/[png|jpeg|gif]/.test(file ? file.type : '')) {
        this.sendToServer(file);
      } else {
        alert('Please select an image file of type .png, .jpeg or .gif');
      }
    };
  };

  sendToServer = (file: File) => {
    this.options.uploadFunc(file.name, file).then(response => {
      if (response) {
        this.insert(response.secure_url);
      }
    });
  };

  insert = (imageSource: string) => {
    const range = this.quill.getSelection();
    const length = this.quill.getLength();
    const index = (range && range.index) ?? length ?? 1;

    const [line] = this.quill.getLine(index);
    if (line && line.domNode.classList.contains('ql-grid')) {
      // Append to existing image grid
      const img = document.createElement('img');
      img.setAttribute('src', imageSource);
      line.domNode.appendChild(img);
    } else {
      this.quill.insertEmbed(index, 'image', imageSource, Quill.sources.USER);
      this.quill.insertText(index + 1, '\n', 'silent');
    }

    this.quill.setSelection(index + 1, 0);
    this.quill.focus();
  };
}

Quill.register('modules/imageUpload', ImageUpload);

export default ImageUpload;
